import { useRef, useState } from "react";
import { useSceneStore } from "../store/sceneStore";
import { useFileImport } from "../hooks/useFileImport";
import { UploadCloudIcon } from "./icons";

export function UploadPanel() {
  const objects = useSceneStore((s) => s.objects);
  const selectedId = useSceneStore((s) => s.selectedId);
  const selectObject = useSceneStore((s) => s.selectObject);
  const removeObject = useSceneStore((s) => s.removeObject);
  const updateObject = useSceneStore((s) => s.updateObject);
  const importFiles = useFileImport();

  const [dragOver, setDragOver] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="panel panel-left">
      <div className="section">
        <h2>Upload</h2>
        <div
          className={`dropzone ${dragOver ? "dragover" : ""}`}
          onClick={() => inputRef.current?.click()}
          onDragOver={(e) => {
            e.preventDefault();
            setDragOver(true);
          }}
          onDragLeave={() => setDragOver(false)}
          onDrop={(e) => {
            e.preventDefault();
            setDragOver(false);
            if (e.dataTransfer.files.length) importFiles(e.dataTransfer.files);
          }}
        >
          <UploadCloudIcon />
          <p className="dropzone-title">Modell hochladen</p>
          <p className="dropzone-hint">Datei hierher ziehen oder klicken zum Auswählen</p>
          <span className="dropzone-formats">Unterstützt STL und OBJ</span>
        </div>
        <input
          ref={inputRef}
          type="file"
          accept=".stl,.obj"
          multiple
          hidden
          onChange={(e) => {
            if (e.target.files?.length) importFiles(e.target.files);
            e.target.value = "";
          }}
        />
      </div>

      <div className="section">
        <h2>Objekte ({objects.length})</h2>
        <div className="object-list">
          {objects.length === 0 && <p className="empty-state">Noch keine Objekte</p>}
          {objects.map((obj) => (
            <div
              key={obj.id}
              className={`object-row ${obj.id === selectedId ? "selected" : ""}`}
              onClick={() => selectObject(obj.id)}
            >
              <span>{obj.name}</span>
              <span className="row-buttons">
                <button
                  title={obj.visible ? "Ausblenden" : "Einblenden"}
                  onClick={(e) => {
                    e.stopPropagation();
                    updateObject(obj.id, { visible: !obj.visible });
                  }}
                >
                  {obj.visible ? "👁" : "🚫"}
                </button>
                <button
                  title="Löschen"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeObject(obj.id);
                  }}
                >
                  ✕
                </button>
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
